import { Controller } from "@hotwired/stimulus"

// Handles toast notifications that auto-dismiss after a timeout.
// Each toast element should have this controller attached.
export default class extends Controller {
  static values = {
    duration: { type: Number, default: 3000 }
  }

  connect() {
    // Start auto-dismiss timer
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    // Add fade-out class for animation
    this.element.classList.add("toast-fade-out")

    // Remove element after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
